module.exports = __webpack_public_path__ + "images/bug_green_size_5_4c4125a13ad216577e17531e5ebf7652.png";